import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdOutlineRefresh, MdOutlineSearch } from "react-icons/md";
import { Input, Button } from "react-daisyui"
import { useCtaStore, CtaStore, CtaStoreContext } from "./store/CtaStore";
import { observer } from "mobx-react";

const EditCtaManagement = observer(() => {
    const { id } = useParams();
    const store = new CtaStore({
        isloading: false,
        editloading: true,
        id: id
      });
    return (
        <CtaStoreContext.Provider value={store}>
            <Screen />
        </CtaStoreContext.Provider>
    )
})

export default EditCtaManagement;

const Screen = observer(() => {
    const { id } = useParams();
    const { 
        name,
        status,
        keywords,
        image,
        imageurl,
        saved,
        loadCta,
        setprice,
        price,
        setProductType,
        Producttypelist,
        ProductType,
        setname,
        setstatus,
        setkeywords,
        setimage,
        editcta,
        setcheckbox,
        setScreen,
        Screen,
        checkbox,
        setlink,
        link,
        setcontent,
        content

      } = useCtaStore();

      const navigate = useNavigate();
      useEffect(() => {
        if (saved) {
          navigate("../ctamanagement");
        }
      }, [saved,loadCta]);
      const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0;
        setcheckbox(value);
        setlink("")
      };

      const goBack = (() => {
        window.history.back();
      })

      const [error, setError] = useState('');

      const handleImageChange = (e) => {
        const file = e.target.files[0];
    
        // Check if a file is selected
        if (file) {
            // Create an image element to check the dimensions
            const img = new Image();
            img.onload = () => {
                const { width, height } = img;
    
                // Validate 1:1 aspect ratio (width must equal height) and minimum size (250x250)
                if (width !== height) {
                    setError('Image must have a 1:1 aspect ratio.');
                    e.target.value = '';  // Reset the input field
                    setimage(null);        // Reset the image state
                } else if (width < 250 || height < 250) {
                    setError('Image must be at least 250x250 pixels.');
                    e.target.value = '';  // Reset the input field
                    setimage(null);        // Reset the image state
                } else {
                    console.log("yeewerewrewr",file)
                    setimage(file);        // Set the image if aspect ratio and size are valid
                    setError('');           // Clear the error
                    // setimageUrl(URL.createObjectURL(file));  // Optional: Set the image URL
                }
            };
            img.src = URL.createObjectURL(file);
        }
    };
    return (
        <>
        <div className='flex justify-between'>
            <div className=" mb-4">
                <p className=" text-2xl font-semibold text-moredarkgreen">Edit CTA</p>
                {/* <p className=" opacity-80 text-sm">Home /City/ Edit</p> */}
            </div>
            <div>
                <Link onClick={goBack} className="btn btn-sm bg-darkgreen text-yellow text-sm hover:bg-yellow hover:text-darkgreen ">Back</Link>
            </div>
        </div>  
            <div className="card bg-base-100 shadow-md p-6 mt-3 mb-10">
                <form onSubmit={(e) => {editcta(id);e.preventDefault()}}>
                <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                        <div>
                            <label htmlFor="screen" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">CTA Title<span className="text-[#f00]">&nbsp;*</span></label>
                            <Input
                                required
                                name="name"
                                placeholder="CTA Title"
                                value={name}
                                onChange={(e)=> {setname(e.target.value)}}
                                id="name"
                                maxLength={25}
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                            <p className="text-red-500 text-sm ">Max CTA Title Limit is 25</p>
                        </div>
                        <div>
                            <label htmlFor="image" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">File<span className="text-[#f00]">&nbsp;*</span></label>
                            <div className=" grid grid-cols-3">
                            <Input
                                name="image"
                                placeholder="Image"
                                accept="image/*"
                                onChange={handleImageChange}
                                type="file"
                                autoComplete="off"
                                required={error ? true : false}
                                className="focus:outline-0 w-full text-sm font-medium rounded-md col-span-2"
                            />
                                 {imageurl && <img className="w-full" src={imageurl}/> }
                            </div>
                            {error ? <p className="text-red-500 text-sm text-error">{error}</p> : (!imageurl ? <p className="text-red-500 text-sm ">Image must have a 1:1 aspect ratio and at least 250x250 pixels.</p> : "")} {/* Error message */}
                        </div>
                        <div>
                            <label htmlFor="Status" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Status<span className="text-[#f00]">&nbsp;*</span></label>
                            <select
                                id="Status"
                                required
                                name="Status"
                                value={status}
                                onChange={(e)=> {setstatus(e.target.value)}}
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                                <option value="1">Active</option>
                                <option value="0">Inactive </option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="is_internal_link" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Is Internal Link</label>
                            <div className=" grid grid-cols-3">
                            <Input
                                name="is_internal_link"
                                id="is_internal_link"
                                defaultChecked={checkbox === 1 }
                                checked={checkbox === 1}
                                onChange={handleCheckboxChange}
                                type="checkbox"
                                autoComplete="off"
                                className="focus:outline-0 w-5 h-5 text-sm font-medium rounded-md "
                            />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="link" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Link<span className="text-[#f00]">&nbsp;*</span></label>
                        {console.log("checkbox",checkbox)}
                        {checkbox ? 
                            <select
                            id="link"
                            required
                            name="link"
                            defaultValue={link}
                            onChange={(e)=> {setlink(e.target.value);}}
                            className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                            <option value="" disabled selected className="hidden">Select Link</option>
                            <option value="Theme">Theme</option>
                            <option value="Explore">Explore</option>
                            <option value="Premium">Premium</option>
                            </select>
                            :
                            <Input
                                required
                                name="link"
                                placeholder="Link"
                                id="link"
                                pattern="https://.*"
                                type="url"
                                defaultValue={link}
                                onChange={(e)=> {setlink(e.target.value)}}
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                            }
                        </div>
                        <div>
                            <label htmlFor="content" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">CTA Content<span className="text-[#f00]">&nbsp;*</span></label>
                            <textarea
                                required={true}
                                name="content"
                                placeholder="CTA Content"
                                rows={1}
                                maxLength={90}
                                id="content"
                                value={content}
                                onChange={(e) => {setcontent(e.target.value) }}
                                autoComplete="off"
                                className="input focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 input-bordered py-2"
                            >
                            </textarea>
                            <p className="text-red-500 text-sm ">Max CTA Content Limit is 90</p>
                        </div>
                       
                    </div>
                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <Link to="/ctamanagement" className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen "><MdOutlineClose className="mr-1"/>Cancel</Link>
                        <button type="submit" className="btn btn-md bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4" ><MdOutlineCheck className="mr-1"/>Update</button>
                    </div>
                </form>
            </div>

        </>
    )
})
